export default __webpack_public_path__ + "static/media/large_ecllipse.fc242826.svg";